(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jannela-launch-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jannela-launch-countdown')) {
  customElements.define('jannela-launch-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.interval) clearInterval(this.interval);
      const end = Date.parse(this.dataset.end);
      if (!Number.isFinite(end)) { this.hidden = true; return; }
      const tick = () => {
        const total = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (total === 0) { this.hidden = true; clearInterval(this.interval); return; }
        this.hidden = false;
        const values = [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60];
        ['hours', 'minutes', 'seconds'].forEach((unit, i) => {
          this.querySelector('[data-' + unit + ']').textContent = String(values[i]).padStart(2, '0');
        });
      };
      tick();
      if (!this.hidden) this.interval = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
